<template>
  <div class="fixed text-sm z-20 w-full bottom-0 left-0 border-t px-2 py-1" :class="[
      $theme.navBg,
      $theme.cardLabelTextColor,
      $theme.navBorderColor,
  ]">
    <nav class="grid text-sm grid-cols-5 gap-1">
      <router-link
          to="/"
          class="relative flex flex-col items-center rounded-lg py-1 text-white/70"
          :class="[
            $route.name === 'home' ? 'text-white' : 'text-white/70'
          ]"
      >
        <HomeIcon
          class="w-6 h-6"
          :fill="$route.name === 'home' ? '#E7B644' : '#ffffffb3'"
        />
        <span class="mt-1">{{ $t('home') }}</span>
      </router-link>
      <router-link
          to="/orders"
          class="flex flex-col items-center rounded-lg py-1"
          :class="[
            $route.name === 'orders' ? `text-white` : 'text-white/70'
          ]"
      >
        <OrdersIcon :fill="$route.name === 'orders' ? '#E7B644' : '#ffffffb3'" class="w-6 h-6" />
        <span class="mt-1">{{ $t('orders') }}</span>
      </router-link>
      <router-link
          to="/stats"
          class="flex flex-col items-center rounded-lg py-1"
          :class="[
            $route.name === 'stats' ? `text-white` : 'text-white/70'
          ]"
      >
        <StatsIcon :fill="$route.name === 'stats' ? '#E7B644' : '#ffffffb3'" class="w-6 h-6" />
        <span class="mt-1">{{ $t('stats') }}</span>
      </router-link>
      <router-link
          to="/setting"
          class="flex flex-col items-center rounded-lg py-1"
          :class="[$route.name === 'setting' ? `text-white` : 'text-white/70']"
      >
        <Cog6ToothIcon :class="[$route.name === 'setting' ? 'm-yellow-color' : 'text-white/70']" class="w-6 h-6" />
        <span class="mt-1">{{ $t('settings') }}</span>
      </router-link>
      <template v-if="isEnabledRefSystem">
        <router-link
            to="/refs"
            class="flex flex-col items-center rounded-lg py-1"
            :class="[$route.name === 'refs' ? `text-white` : 'text-white/70']"
        >
          <UsersIcon :fill="$route.name === 'refs' ? '#E7B644' : '#ffffffb3'" class="w-6 h-6" />
          <span class="mt-1">{{ $t('refs') }}</span>
        </router-link>
      </template>
      <div class="relative">
        <button
          @click="isShowModal = true"
          class="w-full flex flex-col items-center rounded-lg py-1 focus:outline-none"
        >
          <MoreIcon class="w-6 -h-6 text-white/70" />
          <span class="mt-1 text-white/70">{{ $t('more') }}</span>
        </button>
      </div>
    </nav>
  </div>

  <TransitionRoot as="template" :show="isShowModal">
    <Dialog class="relative z-50" @close="isShowModal = false">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      <div class="fixed inset-0 z-50 flex items-end justify-center">
        <TransitionChild
            as="template"
            enter="transform transition ease-in-out duration-300"
            enter-from="translate-y-full opacity-0"
            enter-to="translate-y-0 opacity-100"
            leave="transform transition ease-in-out duration-300"
            leave-from="translate-y-0 opacity-100"
            leave-to="translate-y-full opacity-0"
        >
          <DialogPanel class="w-full rounded-t-3xl px-4 pt-5 pb-4 text-left shadow-xl sm:max-w-lg sm:w-full sm:p-6" :class="[$theme.secondBaseBg]">
            <div>
              <router-link to="/tariff" @click="closePopover" class="group relative flex items-center gap-3 rounded-lg p-2">
                <div class="flex h-10 w-10 flex-none items-center justify-center rounded-full" :class="[$theme.tabsContainerBg]">
                  <CurrencyDollarIcon class="h-6 w-6" :class="[$theme.svgColor]" />
                </div>
                <div>
                  <div :class="$theme.baseTextColor">
                    {{ $t('tariff') }}
                    <span class="absolute inset-0" />
                  </div>
                </div>
              </router-link>
              <router-link to="/setting" @click="closePopover" class="group relative flex items-center gap-3 rounded-lg p-2">
                <div class="flex h-10 w-10 flex-none items-center justify-center rounded-full" :class="[$theme.tabsContainerBg]">
                  <Cog6ToothIcon class="h-6 w-6" :class="[$theme.svgColor]" />
                </div>
                <div>
                  <div :class="$theme.baseTextColor">
                    {{ $t('settings') }}
                    <span class="absolute inset-0" />
                  </div>
                </div>
              </router-link>
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
  <TransitionRoot as="template" :show="isShowCookie">
    <Dialog class="relative z-50" @close="isShowCookie = false">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      <div class="fixed inset-0 z-50 flex items-end justify-center">
        <TransitionChild
            as="template"
            enter="transform transition ease-in-out duration-300"
            enter-from="translate-y-full opacity-0"
            enter-to="translate-y-0 opacity-100"
            leave="transform transition ease-in-out duration-300"
            leave-from="translate-y-0 opacity-100"
            leave-to="translate-y-full opacity-0"
        >
          <DialogPanel class="w-full rounded-t-3xl px-4 pt-5 pb-4 text-left shadow-xl sm:max-w-lg sm:w-full sm:p-6" :class="[$theme.secondBaseBg]">
            <div class="text-center">
              <h3
                class="text-base font-semibold"
                :class="[$theme.baseTextColor]"
              >{{ $t('cookie_title') }}</h3>
              <p class="mt-2 text-sm" :class="[$theme.cardLabelTextColor]">{{ $t('cookie_desc') }}</p>
              <div class=" flex justify-between items-center gap-6 my-4">
                <button
                  @click="acceptCookies"
                  class="flex w-full items-center justify-center px-3 py-3 font-semibold m-yellow-bg rounded-lg text-black uppercase focus:ring-0 focus-visible:outline-none"
                >{{ $t('cookie_accept') }}</button>
                <button
                  @click="declineCookies"
                  class="flex w-full items-center justify-center rounded-lg px-3 py-3 font-semibold uppercase focus:ring-0 focus-visible:outline-none"
                  :class="[$theme.placeBg, $theme.cardLabelTextColor]"
                >{{ $t('cookie_decline') }}</button>
              </div>
              <div>
                <router-link to="/terms"
                  class="inline-flex items-center justify-center py-1"
                  @click="isShowCookie = false"
                >
                  <h4
                    class="text-center"
                    :class="[$theme.baseTextColor]"
                  >
                    {{ $t('terms') }}
                  </h4>
                </router-link>
              </div>
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import HomeIcon from '@/assets/icons/HomeIcon.vue'
import OrdersIcon from '@/assets/icons/OrdersIcon.vue'
import StatsIcon from '@/assets/icons/StatsIcon.vue'
import UsersIcon from '@/assets/icons/UsersIcon.vue'
import MoreIcon from '@/assets/icons/MoreIcon.vue'
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'

import {
  CurrencyDollarIcon,
} from '@heroicons/vue/24/outline'

import {
  Cog6ToothIcon,
} from '@heroicons/vue/24/solid'

export default {
  components: {
    CurrencyDollarIcon,
    UsersIcon,
    HomeIcon,
    OrdersIcon,
    StatsIcon,
    MoreIcon,
    Cog6ToothIcon,
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
  },

  methods: {
    closePopover() {
      this.isShowModal = false;
    },
    acceptCookies() {
      localStorage.setItem('cookiesAccepted', 'true');
      this.isShowCookie = false;
      this.updateCookie(true);
    },
    declineCookies() {
      localStorage.setItem('cookiesAccepted', 'false');
      this.isShowCookie = false;
      this.updateCookie(false);
    },

    updateCookie(cookiesAccepted) {
      this.$api.post('/user/cookie', {
        is_cookie: cookiesAccepted,
      }).then((result) => {
        console.log(result.data)
      }).catch(e => {
        alert(e.message)
        this.error = e
      })
    },
  },

  data() {
    return {
      isShowModal: false,
      isShowCookie: false,
      isEnabledRefSystem: false,
    }
  },

  mounted() {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      this.isShowCookie = true;
    }
    if (window.Telegram?.WebApp?.initDataUnsafe?.user?.id) {
      const tgStorage = window.Telegram.WebApp.Storage;
      tgStorage.getItem('cookiesAccepted', (err, value) => {
        if (!err && !value) this.isShowCookie = true;
      });
    }
  },
}
</script>
